import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyTableState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		r: 50,
		fill: "#F9F9F9"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M68.2001 24H31.7999C29.7312 24 27.7476 24.8216 26.2846 26.2846C24.8216 27.7476 24 29.7312 24 31.7999V68.2001C24 70.2688 24.8216 72.2524 26.2846 73.7154C27.7476 75.1784 29.7312 76 31.7999 76H68.2001C70.2688 76 72.2524 75.1784 73.7154 73.7154C75.1784 72.2524 76 70.2688 76 68.2001V31.7999C76 29.7312 75.1784 27.7476 73.7154 26.2846C72.2524 24.8216 70.2688 24 68.2001 24ZM31.7999 29.2003H68.2001C68.8893 29.2003 69.5507 29.4742 70.0385 29.9615C70.5258 30.4493 70.7997 31.1107 70.7997 31.7999V39.5996L29.1994 39.6002V31.7999C29.1994 31.1107 29.4733 30.4493 29.9605 29.9615C30.4484 29.4742 31.1098 29.2003 31.799 29.2003L31.7999 29.2003ZM44.8 55.2005V44.8H55.2005V55.2005H44.8ZM55.1999 60.4008L55.2005 70.8001H44.8V60.4002L55.1999 60.4008ZM39.5998 55.2005H29.1999V44.8H39.5998V55.2005ZM60.3999 44.8H70.7998V55.2005H60.3999V44.8ZM29.1997 68.2001V60.3997H39.5996V70.7997H31.7993C31.1101 70.7997 30.4487 70.5258 29.9608 70.0385C29.4736 69.5507 29.1997 68.8893 29.1997 68.2001ZM68.2 70.8003L60.3996 70.7997V60.3998H70.7995V68.2001C70.7995 68.8893 70.5257 69.5507 70.0384 70.0385C69.5505 70.5258 68.8891 70.7997 68.2 70.7997V70.8003Z",
		fill: "#D0D0DB"
	})]
});
export default SvgEmptyTableState;
